module.exports = __webpack_public_path__ + "static/media/team_2019.793c58eb.jpg";